import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import OffersCategory from '@/features/partnerOffers/OffersCategory.vue';
import { onMounted, ref } from 'vue';
import { getOffers, logImpressions } from '@/features/partnerOffers/api';
import { PartnerOffer } from '@/features/partnerOffers/model';


export default /*#__PURE__*/_defineComponent({
  __name: 'Offers',
  setup(__props) {


const offers = ref<PartnerOffer[]>([]);

onMounted(() => {
  getOffers().
    then(allOffers => {
      offers.value = allOffers;

      logImpressions("offers/all", allOffers);
    });
});


return (_ctx: any,_cache: any) => {
  const _component_AppPageFrame = _resolveComponent("AppPageFrame")!

  return (_openBlock(), _createBlock(_component_AppPageFrame, { showHeader: "" }, {
    default: _withCtx(() => [
      _createVNode(OffersCategory, {
        class: "p-5",
        title: "Recommended Resources",
        description: "Here are some helpful resources based on your interests and needs.",
        offers: offers.value,
        context: "offers/all"
      }, null, 8, ["offers"])
    ]),
    _: 1
  }))
}
}

})